import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "./SmallLoaderButton";
const WarningModal = React.memo((props) => {
  const handleSubmit = () => {
    props.handleSubmit();
  };

  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={(e) => props.setIsModalOpen(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.message}</Modal.Body>
        <Modal.Footer>
          {props?.loading ? (
            <SmallLoaderButton />
          ) : (
            <Button
              variant=""
              className="add-minutes Mom-btn"
              onClick={handleSubmit}
            >
              <p>Yes</p>
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default WarningModal;
